import { InjectionToken } from '@angular/core';

export const REMOTE_BASE_URL = new InjectionToken<string>('ngxContainerInjector.remoteBaseUrl');
